import SortationDisplay from './SortationDisplay_v3';

export default SortationDisplay;
